export default "__VITE_ASSET__DayPsR$___"